import React from 'react';
import BrandLogo from './BrandLogo';
import './SeoPage.css';

const seoImages = {
  hero: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/seo-page/Hero%20Image.png',
  luxe: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/seo-page/Luxe.png',
  saas: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/seo-page/SaaS%20Scale.png',
  zivara: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/seo-page/Zivara%20Pay.png',
};

const marqueeItems = [
  'Agentic SEO',
  'Search Generative Experience',
  'Entity-Based Optimization',
  'Technical Architecture',
  'Semantic Search',
  'E-E-A-T Scaling',
  'Digital PR Backlinks',
];

const technicalEdgeCards = [
  {
    id: '01',
    title: 'Agentic AI Optimization',
    description:
      'Structure content for LLM discoverability so your brand is cited in AI-generated answers.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    id: '02',
    title: 'Topical Authority Mapping',
    description:
      'Build strong topic clusters that signal category expertise across high-intent search areas.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M3 21l3.8-1 10.8-10.8a2.4 2.4 0 1 0-3.4-3.4L3.4 16.6 3 21z" />
      </svg>
    ),
  },
  {
    id: '03',
    title: 'Performance Architecture',
    description:
      'Optimize crawlability, Core Web Vitals, and technical foundations for lasting ranking growth.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M3 14h4l3-9 4 14 3-8h4" />
      </svg>
    ),
  },
  {
    id: '04',
    title: 'Digital PR Authority',
    description:
      'Acquire strategic mentions and quality backlinks that compound visibility and trust.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
      </svg>
    ),
  },
];

const showcaseCards = [
  {
    title: 'The Fintech Frontier',
    description:
      'Scaled transactional keyword visibility in a crowded finance category with compounding organic growth.',
    tag: 'FINTECH SEO . SCALE . FINANCE',
    image: seoImages.luxe,
  },
  {
    title: 'D2C Dominance',
    description:
      'Built topical authority architecture that moved core commercial terms into stable top positions.',
    tag: 'D2C . DOMINANCE . AUTHORITY',
    image: seoImages.saas,
  },
  {
    title: 'The SaaS Scale',
    description:
      'Expanded international search coverage for enterprise-intent software audiences.',
    tag: 'AI SEO . GLOBAL RANK . SaaS',
    image: seoImages.zivara,
  },
];

const clientCards = [
  {
    quote:
      '"BeyonDigital understands that SEO in India requires a mix of global strategy and local nuance. They did not just get us traffic; they got us transactional intent. Our organic lead volume from Mumbai and Bangalore alone has tripled."',
    name: 'Aarav Malhotra',
    role: 'CEO, Zivara Pay',
  },
  {
    quote:
      '"We couldn’t outspend the giants, so BeyonDigital helped us outsmart them. Their focus on Topical Authority lowered our organic acquisition costs by 40% compared to paid ads."',
    name: 'Saanvi Deshmukh',
    role: 'CGO, AristoStay',
  },
  {
    quote:
      '"BeyonDigital secured our global footprint. We’re now the primary citation for AI-driven queries, transforming our rankings into a dominant digital moat."',
    name: 'Rohan Shah',
    role: 'VP Strategy, Zenith Automation',
  },
];

export default function SeoPage() {
  return (
    <div className="seo-page">
      <nav className="seo-nav">
        <BrandLogo className="seo-nav__logo" size="nav" />
        <ul className="seo-nav__links">
          <li>
            <a href="#work">Work</a>
          </li>
          <li>
            <a href="#services">Services</a>
          </li>
          <li>
            <a href="#about">About</a>
          </li>
        </ul>
        <a href="#contact" className="seo-nav__cta">
          Contact
        </a>
      </nav>

      <section className="seo-hero">
        <div className="seo-hero__visual">
          <img
            src={seoImages.hero}
            alt="SEO hero"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div className="seo-hero__content">
          <p className="seo-hero__eyebrow">Est. 2026 - London</p>
          <h1>
            Architects
            <br />
            <em>Of Organic</em>
            <br />
            Revenue
          </h1>
          <p>
            We blend data-driven strategy with high-end aesthetics to scale your brand presence.
          </p>
          <div className="seo-hero__actions">
            <a href="#work" className="seo-btn seo-btn--dark">
              Explore Styles
            </a>
            <a href="#about" className="seo-btn seo-btn--ghost">
              Our Story ↗
            </a>
          </div>
          <div className="seo-proof">
            <div>
              <strong>210%</strong>
              <span>Average organic growth</span>
            </div>
            <div>
              <strong>85%</strong>
              <span>AI overview visibility</span>
            </div>
            <div>
              <strong>12.4k</strong>
              <span>Keywords won</span>
            </div>
          </div>
        </div>
      </section>

      <section className="seo-marquee">
        <div className="seo-marquee__track">
          {[...marqueeItems, ...marqueeItems].map((item, index) => (
            <React.Fragment key={`${item}-${index}`}>
              <span>{item}</span>
              <span className="seo-marquee__dot">·</span>
            </React.Fragment>
          ))}
        </div>
      </section>

      <section className="seo-section" id="services">
        <header className="seo-section__header">
          <h2>
            The <em>Technical Edge</em>
          </h2>
        </header>
        <div className="seo-grid seo-grid--services">
          {technicalEdgeCards.map((card) => (
            <article className="seo-service-card" key={card.title}>
              <p className="seo-service-card__num">{card.id}</p>
              <div className="seo-service-card__icon">{card.icon}</div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="seo-section" id="work">
        <header className="seo-section__header seo-section__header--showcase">
          <p className="seo-section__tag">Styles we</p>
          <h2>
            Work with
            <br />
            <em>That speaks for themselves.</em>
          </h2>
        </header>
        <div className="seo-grid seo-grid--showcase">
          {showcaseCards.map((card) => (
            <article className="seo-showcase-card" key={card.title}>
              <div className="seo-showcase-card__image">
                <img
                  src={card.image}
                  alt={card.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div className="seo-showcase-card__body">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
                <span>{card.tag}</span>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="seo-section" id="about">
        <header className="seo-section__header seo-section__header--clients">
          <p className="seo-section__tag">A Word</p>
          <h2>
            From our
            <br />
            <em>Beloved Clients</em>
          </h2>
        </header>
        <div className="seo-grid seo-grid--clients">
          {clientCards.map((card) => (
            <blockquote className="seo-client-card" key={card.name}>
              <span className="seo-client-card__mark">"</span>
              <p>{card.quote}</p>
              <cite>
                <strong>{card.name}</strong>
                <span>{card.role}</span>
              </cite>
            </blockquote>
          ))}
        </div>
      </section>

      <section className="seo-cta" id="contact">
        <div className="seo-cta__inner">
          <h2>
            The algorithm is evolving.
            <br />
            <em>Are you?</em>
          </h2>
          <a href="mailto:sdevarsh54@beyondigital.co.uk" className="seo-btn seo-btn--dark">
            Start your SEO audit
          </a>
        </div>
      </section>

      <footer className="seo-footer">
        <div className="seo-footer__top">
          <div className="seo-footer__brand">
            <BrandLogo size="footer" asLink={false} variant="dark" />
            <p>Turning search visibility into measurable growth for modern brands.</p>
          </div>

          <div className="seo-footer__links">
            <div>
              <h4>Agency</h4>
              <a href="/">About</a>
              <a href="/">Work</a>
              <a href="/">Careers</a>
            </div>
            <div>
              <h4>Services</h4>
              <a href="/">Strategy</a>
              <a href="/">Content</a>
              <a href="/">Paid Social</a>
            </div>
            <div>
              <h4>Connect</h4>
              <a href="https://www.instagram.com/beyondigital.co/">Instagram</a>
              <a href="/">LinkedIn</a>
              <a href="/">Twitter/X</a>
            </div>
          </div>
        </div>
        <div className="seo-footer__bottom">London - India - Dubai</div>
      </footer>
    </div>
  );
}
